import type { ComponentProps } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'
import classNames from 'classnames'
import { PuiTextField, StateLabel, Text } from '@pbt/pbt-ui-components'

import { getBraintreeMerchantAccountStatusLabelFlags } from './braintreeMerchantAccountStatusFlags'

type TextFieldField = NonNullable<ComponentProps<typeof PuiTextField>['field']>

type BraintreeMerchantAccountBlockProps = {
  canUpdate: boolean
  formatBraintreeStatus: (status?: string) => string
  merchantAccountStatus?: string
  readOnlyClass: string
  sectionTitle: string
  sectionWithBottomBorderClass: string
  textField: TextFieldField
}

export const BraintreeMerchantAccountBlock = ({
  canUpdate,
  formatBraintreeStatus,
  merchantAccountStatus,
  readOnlyClass,
  sectionTitle,
  sectionWithBottomBorderClass,
  textField,
}: BraintreeMerchantAccountBlockProps) => {
  const { t } = useTranslation('Common')

  return (
    <>
      <Grid container item direction="column" pl={1}>
        <Text strong variant="body2">
          {sectionTitle}
        </Text>
      </Grid>
      <Grid container item direction="column" pb={2} pl={2}>
        <Grid
          container
          item
          alignItems="center"
          className={sectionWithBottomBorderClass}
          justifyContent="flex-start"
        >
          <Grid item xs={3}>
            <Text strong variant="body2">
              {t('STATUS')}
            </Text>
          </Grid>
          <Grid item>
            <StateLabel
              {...getBraintreeMerchantAccountStatusLabelFlags(
                merchantAccountStatus,
              )}
            >
              {formatBraintreeStatus(merchantAccountStatus)}
            </StateLabel>
          </Grid>
        </Grid>
        <Grid
          item
          className={classNames({
            [readOnlyClass]: !canUpdate,
          })}
          md={3}
          pr={2}
        >
          <PuiTextField field={textField} label={textField.label} />
        </Grid>
      </Grid>
    </>
  )
}
